import React from 'react';
import styled from 'styled-components';
import LanguageLink from '../../elements/LanguageLink';
import { NavLink } from 'react-router-dom';


const StyledLink = styled(LanguageLink)`
    text-decoration: none;
    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
    }
`;

export const StyledBlogLink = styled(NavLink)`
    text-decoration: none;
    &:focus, &:hover, &:visited, &:link, &:active {
        text-decoration: none;
    }
`;

export default props => <StyledLink {...props} />;



// WEBPACK FOOTER //
// ./src/blocks/StyledLink/index.jsx